import React from 'react';
import PropTypes from 'prop-types';

import {
    Image,
    Text,
    Flex,
    Spacer,
} from '@zillow/constellation';

import BulletPoint from 'app/shared/images/BulletPoint.svg';

import {
    StyledIconContainer,
    StyledBar,
    StyledInfoContainer,
} from './StyledComponents';

const propTypes = {
    infos: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const WizConvertListingInfo = ({
    infos,
}) => (
    <>
        <StyledBar />
        <StyledInfoContainer>
            {infos.map((infoText, index) => (
                <Flex key={`info-${index}`} display="flex">
                    <StyledIconContainer>
                        <Image src={BulletPoint} />
                    </StyledIconContainer>
                    <Spacer paddingLeft="xs" paddingBottom="md">
                        <Text fontType="body">{infoText}</Text>
                    </Spacer>
                </Flex>
            ))}
        </StyledInfoContainer>
    </>
);

WizConvertListingInfo.propTypes = propTypes;

export default WizConvertListingInfo;
